import {IQuery} from '../../interfaces/models'
import {FeatureLayerInfo} from '../../models/FeatureLayerInfo'
import {getMapService} from '../../reducers/map'
import {WFSCrudService} from '..'
import {XyGisCrudService} from '..'
import {Feature, Geometry, Extent} from '../../models'
import {ISourceApplyEdits, ITypeFeaturesPair} from '../../interfaces/services'
import {TypeKeyIdFeaturesPair} from '../../interfaces/reducers'

export class RemoteGisCrudService {
  WFSCrudService: WFSCrudService
  XyGisCrudService: XyGisCrudService
  protected sourceEdits: TypeKeyIdFeaturesPair = {}
  constructor(WFSCrudService: WFSCrudService, XyGisCrudService: XyGisCrudService) {
    this.WFSCrudService = WFSCrudService
    this.XyGisCrudService = XyGisCrudService
    this.applyEdits = this.applyEdits.bind(this)
    this.identify = this.identify.bind(this)
    this.execute = this.execute.bind(this)
    this.executeForCount = this.executeForCount.bind(this)
    this.executeForExtent = this.executeForExtent.bind(this)
    this.executeForIds = this.executeForIds.bind(this)
  }

  public updateEdits(sourceEdits: TypeKeyIdFeaturesPair) {
    this.sourceEdits = sourceEdits // TODO: change incoming features according to the pending changes
  }

  public attachAttachments(typeFeaturesPair: ITypeFeaturesPair): Promise<Feature[]> {
    if (typeFeaturesPair.layerInfo.sourceDescription.serviceType == 'wfs') {
      return this.WFSCrudService.attachAttachments(typeFeaturesPair)
    } else if (typeFeaturesPair.layerInfo.sourceDescription.serviceType == 'xyGis') {
      return this.XyGisCrudService.attachAttachments(typeFeaturesPair)
    }
    throw new Error('wtf')
  }

  public applyEdits(applyEdits: ISourceApplyEdits[]): Promise<ISourceApplyEdits[]> {
    return new Promise((resolve, reject) => {
      const applyWfsEdits: ISourceApplyEdits[] = []
      const applyXyEdits: ISourceApplyEdits[] = []
      applyEdits.forEach(a => {
        if (a.layerInfo.sourceDescription.serviceType == 'wfs') {
          applyWfsEdits.push(a)
        } else if (a.layerInfo.sourceDescription.serviceType == 'xyGis') {
          applyXyEdits.push(a)
        } else {
          throw new Error('wtf')
        }
      })
      const promises: Promise<ISourceApplyEdits[]>[] = []
      if (applyWfsEdits.length > 0) {
        promises.push(this.WFSCrudService.applyEdits(applyWfsEdits))
      } else if (applyXyEdits.length > 0) {
        promises.push(this.XyGisCrudService.applyEdits(applyXyEdits))
      }
      Promise.all(promises)
        .then(results => resolve([].concat.apply([], results)))
        .catch(error => reject(error))
    })
  }

  public identify(
    featureLayerInfos: Array<FeatureLayerInfo>,
    geometry: Geometry
  ): Promise<Array<{layerInfo: FeatureLayerInfo; features: Array<Feature>}>> {
    return new Promise((resolve, reject) => {
      const promises: Array<Promise<{layerInfo: FeatureLayerInfo; features: Array<Feature>; error?: Error}>> = []
      ;(featureLayerInfos as Array<FeatureLayerInfo>).forEach(fli => {
        if (fli.sourceDescription.serviceType == 'wfs') {
          promises.push(this.WFSCrudService.identify(fli, getMapService().getCode(), new Extent(geometry.getExtent())))
        } else if (fli.sourceDescription.serviceType == 'xyGis') {
          promises.push(
            this.XyGisCrudService.identify(fli, getMapService().getCode(), new Extent(geometry.getExtent()))
          )
        } else {
          throw new Error('Not implemented')
        }
      })
      Promise.all(promises)
        .then(result => {
          const payload: Array<{layerInfo: FeatureLayerInfo; features: Array<Feature>}> = []
          result.forEach(res => {
            payload.push({layerInfo: res.layerInfo, features: res.features})
          })
          resolve(payload)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  public execute(featureLayerInfo: FeatureLayerInfo, query: IQuery): Promise<Array<Feature>> {
    const layerInfo = featureLayerInfo
    if (layerInfo.sourceDescription.serviceType == 'wfs') {
      return this.WFSCrudService.execute(layerInfo, query)
    } else if (layerInfo.sourceDescription.serviceType == 'xyGis') {
      return this.XyGisCrudService.execute(layerInfo, query)
    }
    throw new Error('Not implemented')
  }

  public executeForCount(featureLayerInfo: FeatureLayerInfo, query: IQuery): Promise<number> {
    const layerInfo = featureLayerInfo
    if (layerInfo.sourceDescription.serviceType == 'wfs') {
      return this.WFSCrudService.executeForCount(layerInfo, query)
    } else if (layerInfo.sourceDescription.serviceType == 'xyGis') {
      return this.XyGisCrudService.executeForCount(layerInfo, query)
    }
    throw new Error('Not implemented')
  }

  public executeForExtent(featureLayerInfo: FeatureLayerInfo, query: IQuery & any): Promise<any> {
    return new Promise((resolve, reject) => {})
  }

  public executeForIds(featureLayerInfo: FeatureLayerInfo, query: IQuery): Promise<number[]> {
    return new Promise((resolve, reject) => {})
  }
}
